export default __webpack_public_path__ + "static/media/Linked_List_Insertion_3.1b152521.gif";